var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Unidade Temática",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarUnidadesTematicas.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Código da Habilidade",
      "outlined": "",
      "dense": ""
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.buscarUnidadesTematicas.apply(null, arguments);
      }
    },
    model: {
      value: _vm.form.filters.codigoHabilidade,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "codigoHabilidade", $$v);
      },
      expression: "form.filters.codigoHabilidade"
    }
  })], 1), _c('sca-select-ativo', {
    attrs: {
      "cols": 3,
      "config": {
        labelAtivo: 'Ativo',
        labelInativo: 'Inativo',
        label: 'Situação'
      }
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarUnidadesTematicas();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterUnidadeTematica();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listUnidadesTematicas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "no-data-text": this.$user.permissions.includes('unidade.tematica.listar') ? _vm.dataText : 'Não há registros a serem exibidos.',
      "show-expand": ""
    },
    scopedSlots: _vm._u([{
      key: `item.habilidades`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.habilidades.join(' / ')) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sca-label-ativo', {
          attrs: {
            "ativo": item.ativo,
            "config": {
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo'
            }
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref3) {
        var headers = _ref3.headers,
          item = _ref3.item;
        return [_c('td', {
          staticClass: "blue-grey lighten-5",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('p', {
          staticClass: "ml-4 my-0 text-wrap mx-70vw"
        }, [_vm._v(_vm._s(item.descricao))])])];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sca-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarUnidadeTematica(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterUnidadeTematica(item);
            }
          }
        }), _c('sca-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarUnidadesTematicas(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarUnidadeTematicaDialog', {
    attrs: {
      "visible": _vm.dialogManterUnidadeTematica.visible,
      "content": _vm.dialogManterUnidadeTematica.content,
      "edit": _vm.dialogManterUnidadeTematica.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterUnidadeTematica.close();
      },
      "onSave": function ($event) {
        return _vm.buscarUnidadesTematicas();
      }
    }
  }), _c('VisualizarUnidadeTematicaDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarUnidadeTematica.visible,
      "content": _vm.dialogVisualizarUnidadeTematica.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarUnidadeTematica.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }